module.exports = __webpack_public_path__ + "img/9f005733-22fb-4047-b269-b334375cae42.79c8fe45.png";